import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAppSelector } from '../../hooks/redux';
import { LoadingSpinner } from '../ui/LoadingSpinner';

interface AuthGuardProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({
  children,
  redirectTo = '/dashboard',
}) => {
  const { isAuthenticated, isLoading, userStatus } = useAppSelector(
    state => state.auth
  );

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  // If user is authenticated and we know their status, redirect appropriately
  if (isAuthenticated && userStatus !== null) {
    if (userStatus === 'onboarding' || userStatus === 'pending_verification') {
      return <Navigate to="/onboarding" replace />;
    } else if (userStatus === 'active') {
      return <Navigate to={redirectTo} replace />;
    } else if (userStatus === 'suspended') {
      return <Navigate to="/suspended" replace />;
    }
  }

  // User is not authenticated, or profile status is still loading - show children
  return <>{children}</>;
};
